/* Alva — Klaviyo complete-cart tracking v1.7 (property-preserving gift recovery and applied discount codes). Moved from snippets/alva-klaviyo-cart-tracking.liquid (inline <script>) to a deferred asset Oct 7 2026 (PDP speed audit). Logic unchanged; config is still read from #alva-klaviyo-cart-tracking-config. */
(function () {
  if (window.__alvaFullCartTrackingV1) return;
  window.__alvaFullCartTrackingV1 = true;

  var configNode = document.getElementById('alva-klaviyo-cart-tracking-config');
  var config = {};
  var storageKey = 'alva_klaviyo_full_cart_state_v1';
  var syncTimer = null;
  var retryTimer = null;
  var sequence = 0;
  var lastPayload = null;
  var lastDispatch = null;
  var handledIdentityVersion = 0;
  var pendingIdentityVersion = 0;
  var identityKey = '';
  var privacyWaitTimer;
  var privacyWaitAttempts = 0;
  var cartReadRetryAttempts = 0;
  var pendingStates = [];
  var sendingState = false;
  var sendRetryTimer = null;
  var sdkWaitAttempts = 0;
  var scheduledCart = null;

  try {
    config = JSON.parse(configNode ? configNode.textContent : '{}');
  } catch (error) {}

  function storageRead() {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || 'null');
    } catch (error) {
      return null;
    }
  }

  function storageWrite(value) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(value));
    } catch (error) {}
  }

  function simpleHash(value) {
    var hash = 2166136261;
    var input = String(value || '');
    for (var index = 0; index < input.length; index += 1) {
      hash ^= input.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(36);
  }

  function absoluteUrl(value) {
    if (!value) return null;
    try {
      return new URL(value, window.location.origin).href;
    } catch (error) {
      return null;
    }
  }

  function round2(value) {
    return Math.round((Number(value) || 0) * 100) / 100;
  }

  // Shopify.currency.rate is the presentment-to-shop-currency rate the storefront is rendering with
  // (1 when the shop currency is active). Divide presentment amounts by it to get shop-currency amounts.
  function currencyContext(cart) {
    var shopCurrency = config.shop_currency || 'USD';
    var presentment = cart.currency || shopCurrency;
    var rate = 1;
    try {
      var shopifyCurrency = window.Shopify && window.Shopify.currency;
      if (shopifyCurrency && shopifyCurrency.active && shopifyCurrency.active !== shopCurrency) {
        var parsed = parseFloat(shopifyCurrency.rate);
        if (isFinite(parsed) && parsed > 0) rate = parsed;
      }
    } catch (error) {}
    if (presentment === shopCurrency) rate = 1;
    return { shop_currency: shopCurrency, presentment_currency: presentment, rate: rate };
  }

  function scalarProperties(properties) {
    var output = {};
    if (!properties || typeof properties !== 'object') return output;
    Object.keys(properties).forEach(function (key) {
      if (!key || key.charAt(0) === '_') return;
      var value = properties[key];
      if (value === null || value === undefined || value === '') return;
      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        output[key] = String(value).slice(0, 500);
      }
    });
    return output;
  }

  function hasLineProperties(properties) {
    if (!properties || typeof properties !== 'object') return false;
    return Object.keys(properties).some(function (key) {
      var value = properties[key];
      return value !== null && value !== undefined && value !== '';
    });
  }

  function lineItem(item, money) {
    var sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    var unitPriceMinor = Number(item.final_price != null ? item.final_price : item.price) || 0;
    var rowTotalMinor = Number(item.final_line_price != null ? item.final_line_price : unitPriceMinor * item.quantity) || 0;
    var productUrl = absoluteUrl(item.url);
    var imageUrl = absoluteUrl(item.image || item.featured_image && item.featured_image.url);
    var properties = scalarProperties(item.properties);
    var unitPriceShop = round2(unitPriceMinor / 100 / money.rate);
    var rowTotalShop = round2(rowTotalMinor / 100 / money.rate);

    return {
      line_key: String(item.key || ''),
      variant_id: String(item.variant_id || item.id || ''),
      product_id: String(item.product_id || ''),
      product_title: item.product_title || item.title || '',
      variant_title: item.variant_title || '',
      sku: item.sku || '',
      quantity: Number(item.quantity) || 0,
      image_url: imageUrl,
      product_url: productUrl,
      unit_price_minor: unitPriceMinor,
      unit_price: unitPriceShop,
      row_total_minor: rowTotalMinor,
      row_total: rowTotalShop,
      presentment_unit_price: unitPriceMinor / 100,
      presentment_row_total: rowTotalMinor / 100,
      properties: properties,
      selling_plan_id: sellingPlan && sellingPlan.id ? String(sellingPlan.id) : null,
      selling_plan_name: sellingPlan && sellingPlan.name ? sellingPlan.name : null,
      ProductID: String(item.product_id || ''),
      VariantID: String(item.variant_id || item.id || ''),
      SKU: item.sku || '',
      ProductName: item.product_title || item.title || '',
      VariantTitle: item.variant_title || '',
      Quantity: Number(item.quantity) || 0,
      ItemPrice: unitPriceShop,
      RowTotal: rowTotalShop,
      ProductURL: productUrl,
      ImageURL: imageUrl
    };
  }

  function recoveryResult(cart) {
    var items = Array.isArray(cart.items) ? cart.items : [];
    var seenVariants = {};
    var supported = items.length > 0;
    var reason = null;
    var giftLine = null;
    var discounts = [];
    // Shopify permalinks preserve properties on the FIRST line only.
    // Allow only the exact, non-personal Maestro gift marker; retain all other guards.
    var giftPans = {
      '50609083121981': ['45002068951357', '49182534697277', '50608867803453'],
      '50609101603133': ['45002068984125', '49182534730045', '50608867836221'],
      '50609101635901': ['45002069016893', '49182534762813', '50608867868989']
    };

    items.forEach(function (item) {
      var variantId = String(item.variant_id || item.id || '');
      var quantity = Number(item.quantity);
      if (!/^\d+$/.test(variantId) || !Number.isSafeInteger(quantity) || quantity < 1) {
        supported = false;
        reason = reason || 'missing_variant';
      }
      if (seenVariants[variantId]) {
        supported = false;
        reason = reason || 'duplicate_variant';
      }
      seenVariants[variantId] = true;
      if (hasLineProperties(item.properties)) {
        var keys = Object.keys(item.properties).filter(function (key) {
          return item.properties[key] !== null && item.properties[key] !== undefined && item.properties[key] !== '';
        });
        var knownGift = keys.length === 1 && keys[0] === '_alva_maestro_gift' &&
          item.properties._alva_maestro_gift === '20261020' && Boolean(giftPans[variantId]);
        var matchingPans = knownGift ? items.reduce(function (sum, pan) {
          return sum + (giftPans[variantId].indexOf(String(pan.variant_id || pan.id || '')) >= 0 ? Number(pan.quantity) || 0 : 0);
        }, 0) : 0;
        if (!knownGift || quantity > 2 || quantity > matchingPans) {
          supported = false;
          reason = reason || 'line_properties';
        } else if (giftLine) {
          supported = false;
          reason = reason || 'multiple_property_lines';
        } else {
          giftLine = item;
        }
      }
      if (item.selling_plan_allocation) {
        supported = false;
        reason = reason || 'selling_plan';
      }
    });

    // Carry only codes already accepted by Shopify; never invent or grant a discount.
    (Array.isArray(cart.discount_codes) ? cart.discount_codes : []).forEach(function (entry) {
      if (entry.applicable !== true) return;
      var code = typeof entry.code === 'string' ? entry.code : '';
      if (!code || code.indexOf(',') !== -1 || code.length > 255) {
        supported = false;
        reason = reason || 'unsupported_discount_code';
      } else if (discounts.indexOf(code) < 0) {
        discounts.push(code);
      }
    });
    if (!supported) return { supported: false, url: null, reason: reason || 'empty_cart' };

    var root = String(config.root_url || '/').replace(/\/?$/, '/');
    var ordered = giftLine ? [giftLine].concat(items.filter(function (item) { return item !== giftLine; })) : items;
    var lines = ordered.map(function (item) {
      return String(item.variant_id || item.id) + ':' + String(item.quantity);
    }).join(',');
    var query = '?storefront=true';
    if (giftLine) query += '&properties=eyJfYWx2YV9tYWVzdHJvX2dpZnQiOiIyMDI2MTAyMCJ9';
    if (discounts.length) query += '&discount=' + discounts.map(encodeURIComponent).join(',');
    return { supported: true, url: absoluteUrl(root + 'cart/' + lines + query), reason: null };
  }

  function privacyAllowsTracking() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return false;

    function allowed(method) {
      try {
        return typeof privacy[method] === 'function' && privacy[method]() === true;
      } catch (error) {
        return false;
      }
    }

    return allowed('analyticsProcessingAllowed') && allowed('marketingAllowed');
  }

  function isThemePreview() {
    var shopify = window.Shopify || {};
    if (shopify.designMode || (shopify.theme && shopify.theme.role !== 'main')) return true;
    if (new URLSearchParams(window.location.search).has('preview_theme_id')) return true;
    return Boolean(document.querySelector('script[src*="theme-hot-reload"], script[src*="preview-bar"], iframe#preview-bar-iframe, iframe#PBarNextFrame'));
  }

  function cartIdentity(cart) {
    var token = String(cart.token || '');
    if (token) return 'shopify_' + simpleHash(token) + '_' + token.length;
    var stored = pendingStates.length ? pendingStates[pendingStates.length - 1].storage : storageRead();
    if (stored && stored.cart_id && String(stored.cart_id).indexOf('session_') === 0) return stored.cart_id;
    return 'session_' + simpleHash(window.location.origin + ':' + Date.now() + ':' + Math.random());
  }

  // v1.3: fingerprint the cart lines plus the normalised shop-currency value. Repeated drawer refreshes,
  // reloads and currency-only re-renders remain unchanged, while real line or discount/value changes emit.
  function cartFingerprint(cart) {
    var items = Array.isArray(cart.items) ? cart.items : [];
    var money = currencyContext(cart);
    var valueShopMinor = Math.round((Number(cart.total_price) || 0) / money.rate);
    var lines = items.map(function (item) {
      return {
        variant_id: String(item.variant_id || item.id || ''),
        quantity: Number(item.quantity) || 0,
        properties: hasLineProperties(item.properties) ? scalarProperties(item.properties) : null,
        selling_plan: item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id || null
      };
    }).sort(function (a, b) {
      return a.variant_id < b.variant_id ? -1 : a.variant_id > b.variant_id ? 1 : 0;
    });
    return simpleHash(JSON.stringify({
      token: String(cart.token || ''),
      lines: lines,
      value_shop_minor: valueShopMinor,
      recovery_url: recoveryResult(cart).url
    }));
  }

  function buildState(cart, reason, force) {
    var previous = pendingStates.length ? pendingStates[pendingStates.length - 1].storage : storageRead();
    var cartId = cartIdentity(cart);
    var fingerprint = cartFingerprint(cart);
    var itemCount = Number(cart.item_count) || 0;
    var sameCart = previous && previous.cart_id === cartId;

    if (sameCart && previous.fingerprint === fingerprint &&
        (!force || itemCount === 0 || (identityKey && previous.identity_key === identityKey))) return null;

    if (!sameCart && itemCount === 0) {
      storageWrite({ cart_id: cartId, cart_version: 0, fingerprint: fingerprint, item_count: 0 });
      return null;
    }

    var version = sameCart ? Number(previous.cart_version || 0) + 1 : 1;
    var money = currencyContext(cart);
    var recovery = recoveryResult(cart);
    var items = (Array.isArray(cart.items) ? cart.items : []).map(function (item) { return lineItem(item, money); });
    var capturedAt = new Date().toISOString();
    var valueMinor = Number(cart.total_price) || 0;
    var valueShop = round2(valueMinor / 100 / money.rate);
    var forceNonce = force ? ':identified_' + Date.now().toString(36) + '_' + simpleHash(Math.random()) : '';
    var idempotencyKey = cartId + ':' + version + ':' + fingerprint + forceNonce;
    var payload = {
      schema_version: config.schema_version || '1.1',
      cart_id: cartId,
      cart_version: version,
      captured_at: capturedAt,
      currency: money.shop_currency,
      presentment_currency: money.presentment_currency,
      presentment_value: valueMinor / 100,
      currency_rate: money.rate,
      item_count: itemCount,
      cart_value_minor: valueMinor,
      cart_value_major: valueShop,
      line_items: items,
      recovery_url: recovery.url,
      recovery_supported: recovery.supported,
      recovery_unsupported_reason: recovery.reason,
      source: config.source || 'alva_shopify_theme',
      is_theme_preview: isThemePreview(),
      event_reason: reason || 'cart_sync',
      idempotency_key: idempotencyKey,
      '$event_id': idempotencyKey,
      '$value': valueShop,
      '$currency_code': money.shop_currency,
      ItemNames: items.map(function (item) { return item.product_title; }),
      Items: items,
      CheckoutURL: recovery.url,
      RecoveryURL: recovery.url,
      RecoveryEligible: itemCount > 0 && recovery.supported
    };

    return {
      eventName: itemCount > 0 ? 'ALVA Cart Updated' : 'ALVA Cart Emptied',
      payload: payload,
      storage: {
        cart_id: cartId,
        cart_version: version,
        fingerprint: fingerprint,
        item_count: itemCount,
        captured_at: capturedAt,
        identity_key: identityKey || (sameCart && previous.identity_key) || ''
      }
    };
  }

  function acceptState(state) {
    storageWrite(state.storage);
    lastPayload = state.payload;
    lastDispatch = {
      event_name: state.eventName,
      transport: 'klaviyo.track',
      dispatched_at: new Date().toISOString()
    };
    document.dispatchEvent(new CustomEvent('alva:klaviyo-cart-state', {
      detail: {
        event_name: state.eventName,
        payload: state.payload,
        transport: 'klaviyo.track'
      }
    }));
  }

  function drainPending(resume) {
    if (sendingState || !pendingStates.length || isThemePreview() || !privacyAllowsTracking()) return;
    var state = pendingStates[0];
    if (resume) {
      state.attempts = 0;
      sdkWaitAttempts = 0;
      clearTimeout(sendRetryTimer);
    }
    if (!window.klaviyo || typeof window.klaviyo.track !== 'function') {
      if (sdkWaitAttempts >= 30) return;
      sdkWaitAttempts += 1;
      clearTimeout(sendRetryTimer);
      sendRetryTimer = setTimeout(function () { drainPending(false); }, 1000);
      return;
    }
    if (state.attempts >= 3) return;
    sendingState = true;
    state.attempts = (state.attempts || 0) + 1;
    function failed() {
      sendingState = false;
      if (state.attempts < 3) {
        clearTimeout(sendRetryTimer);
        sendRetryTimer = setTimeout(function () { drainPending(false); }, 1500 * state.attempts);
      }
    }
    var delivery;
    try {
      delivery = window.klaviyo.track(state.eventName, state.payload);
    } catch (error) {
      failed();
      return;
    }
    Promise.resolve(delivery).then(function (accepted) {
      if (accepted !== true) { failed(); return; }
      acceptState(state);
      pendingStates.shift();
      sendingState = false;
      sdkWaitAttempts = 0;
      drainPending(false);
    }, failed);
  }

  function dispatchToKlaviyo(state) {
    if (!state) return false;
    pendingStates.push(state);
    drainPending(true);
    return true;
  }

  function cartEndpoint() {
    if (config.cart_url) return config.cart_url;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root.replace(/\/?$/, '/') + 'cart.js';
  }

  function syncCart(reason, scheduledSequence, force, suppliedCart) {
    if (isThemePreview()) return Promise.resolve({ status: 'theme_preview_blocked' });
    if (!privacyAllowsTracking()) return Promise.resolve({ status: 'consent_blocked' });
    var identityVersion = pendingIdentityVersion;
    force = force || identityVersion > handledIdentityVersion;
    if (force && identityVersion) reason = 'profile_identified';
    var requestSequence = scheduledSequence || ++sequence;

    var read = suppliedCart && Array.isArray(suppliedCart.items) && typeof suppliedCart.item_count === 'number' ?
      Promise.resolve(suppliedCart) : fetch(cartEndpoint(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart read failed');
      return response.json();
    });
    return read.then(function (cart) {
      if (requestSequence !== sequence) return { status: 'stale' };
      var state = buildState(cart, reason, force);
      if (!state) {
        handledIdentityVersion = Math.max(handledIdentityVersion, identityVersion);
        cartReadRetryAttempts = 0;
        drainPending(true);
        return { status: 'unchanged', cart: cart };
      }
      if (!dispatchToKlaviyo(state)) throw new Error('Klaviyo dispatch failed');
      handledIdentityVersion = Math.max(handledIdentityVersion, identityVersion);
      cartReadRetryAttempts = 0;
      return { status: 'queued', event_name: state.eventName, payload: state.payload, cart: cart };
    }).catch(function () {
      if (cartReadRetryAttempts >= 2) return { status: 'retry_limit_reached' };
      cartReadRetryAttempts += 1;
      clearTimeout(retryTimer);
      retryTimer = setTimeout(function () { scheduleSync('cart_read_retry', 0); }, 1500 * cartReadRetryAttempts);
      return { status: 'retry_scheduled' };
    });
  }

  function scheduleSync(reason, delay, force, cart) {
    clearTimeout(syncTimer);
    scheduledCart = cart && Array.isArray(cart.items) && typeof cart.item_count === 'number' ? cart : null;
    var scheduledSequence = ++sequence;
    syncTimer = setTimeout(function () {
      var snapshot = scheduledCart;
      scheduledCart = null;
      syncCart(reason, scheduledSequence, force, snapshot);
    }, typeof delay === 'number' ? delay : 350);
  }


  // v1.1: the first sync used to race Shopify's customer-privacy API (it loads asynchronously), so the
  // initial_load event was sent before consent state was known. Wait for the API when it is available.
  function whenPrivacyReady(callback) {
    var done = false;
    function finish() {
      if (done) return;
      if (window.Shopify && window.Shopify.customerPrivacy) {
        done = true;
        clearTimeout(privacyWaitTimer);
        callback();
      } else if (privacyWaitAttempts++ < 30) {
        clearTimeout(privacyWaitTimer);
        privacyWaitTimer = setTimeout(finish, 1000);
      }
    }
    if (window.Shopify && window.Shopify.customerPrivacy) return finish();
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], finish);
      }
    } catch (error) {}
    finish();
  }

  function queueIdentityRefire(identityVersion, email) {
    identityVersion = Number(identityVersion || 0) || handledIdentityVersion + 1;
    if (identityVersion <= handledIdentityVersion || identityVersion <= pendingIdentityVersion) return;
    pendingIdentityVersion = identityVersion;
    email = String(email || '').trim().toLowerCase();
    if (email) identityKey = simpleHash(email) + '_' + email.length;
    scheduleSync('profile_identified', 0);
  }

  function bind() {
    ['cart:change', 'cart:refresh'].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) { scheduleSync(eventName, undefined, false, event.detail && event.detail.cart); });
    });
    document.addEventListener('cart-drawer:refreshed', function (event) {
      scheduleSync('cart-drawer:refreshed', 750, false, event.detail && event.detail.cart);
    });
    document.addEventListener('visitorConsentCollected', function () { scheduleSync('consent_collected', 0); });
    window.addEventListener('online', function () { scheduleSync('online', 0); });
    document.addEventListener('alva:klaviyo-identified', function (event) {
      queueIdentityRefire(event.detail && event.detail.identity_version, event.detail && event.detail.email);
    });
    if (window.__alvaKlaviyoIdentityVersion) {
      queueIdentityRefire(window.__alvaKlaviyoIdentityVersion, window.__alvaKlaviyoIdentityEmail);
    }
    window.addEventListener('pageshow', function (event) {
      if (event && event.persisted) scheduleSync('pageshow', 500);
    });
    whenPrivacyReady(function () {
      if (handledIdentityVersion) return;
      scheduleSync('initial_load', 650);
    });
  }

  window.AlvaKlaviyoCartTracking = {
    sync: function (reason, options) { return syncCart(reason || 'manual', null, Boolean(options && options.force)); },
    getLastPayload: function () { return lastPayload; },
    getLastDispatch: function () { return lastDispatch; },
    getStoredState: storageRead,
    getPendingCount: function () { return pendingStates.length; },
    version: '1.6'
  };

  bind();
})();
